import { createFileRoute } from "@tanstack/react-router";
import Mentoria from "@/pages/Mentoria";
import { pageHead } from "@/lib/pageHead";

export const Route = createFileRoute("/mentoria-retail")({
  head: () => pageHead("mentoring", "es"),
  component: Mentoria,
});
